// Optical kerning — port từ compose_words.py::_compose_kerned (thuần JS)
function percentile(arr, p){
  const a=[...arr].sort((x,y)=>x-y), n=a.length;
  if(n===1) return a[0];
  const rank=(p/100)*(n-1), lo=Math.floor(rank), hi=Math.ceil(rank);
  return lo===hi ? a[lo] : a[lo]+(a[hi]-a[lo])*(rank-lo);
}
function inkExtent(g){ // [count, top, bottom] theo hàng-glyph có ink
  let top=-1, bot=-1, n=0;
  for(let y=0;y<g.h;y++){ if(g.L[y]!==null){ if(top<0)top=y; bot=y; n++; } }
  return [n, top, bot];
}
function computePositions(glyphs, canvas_h, gap, space_px, o={}){
  const {edge_pct=98, min_shared=8, safety=0.5, short_frac=0.45, short_tuck=0.5, short_tuck_cap=0.09}=o;
  const cr=new Array(canvas_h).fill(NaN);
  const pos=[]; let prev_x=null, prev_w=0, flow_x=0, prevShort=false;
  for(const g of glyphs){
    if(g.space){ flow_x+=space_px; cr.fill(NaN); prev_x=null; prev_w=0; prevShort=false; pos.push(null); continue; }
    const w=g.w, gh=g.h, yo=g.yoff;
    // glyph "thấp" (gạch nối, chấm…): ink cao < short_frac*khung -> KHÔNG kern quang học, dùng bbox
    const ext=inkExtent(g); const isShort = ext[0]>0 && (ext[2]-ext[1]+1) < short_frac*canvas_h;
    let crHasVal=false, crMax=-Infinity;
    for(let y=0;y<canvas_h;y++){ const v=cr[y]; if(!Number.isNaN(v)){ crHasVal=true; if(v>crMax)crMax=v; } }
    const diffs=[];
    for(let i=0;i<gh;i++){ const l=g.L[i]; if(l===null) continue; const y=yo+i; const v=cr[y]; if(!Number.isNaN(v)) diffs.push(v-l); }
    let x;
    if(isShort || prevShort){                          // dấu phân cách (gạch/chấm): tuck 1 PHẦN về optical -> khớp chữ hở (L/J) mà không hút hẳn vào
      const x_met = Math.round(flow_x);
      let x_opt;
      if(diffs.length>=min_shared) x_opt = Math.ceil(percentile(diffs,edge_pct)+gap);
      else if(diffs.length>0) x_opt = Math.ceil(Math.max(...diffs)+gap);
      else x_opt = crHasVal ? Math.round(crMax)+gap : Math.floor(flow_x);
      const tuck = Math.min(short_tuck*Math.max(0, x_met - x_opt), short_tuck_cap*canvas_h);   // kéo GẦN 1 phần, CAP để không hút sâu vào chữ hở (L/J)
      x = Math.max(Math.round(x_met - tuck), prev_x!==null? prev_x+1:0);
    } else if(diffs.length>=min_shared){
      x=Math.ceil(percentile(diffs,edge_pct)+gap);
      x=Math.max(x, prev_x!==null? prev_x+1:0);
    } else if(diffs.length>0){
      const xk=Math.ceil(Math.max(...diffs)+gap);
      const base = crHasVal? crMax+gap : flow_x;
      x=Math.max(xk, base-Math.floor(safety*Math.min(prev_w||w,w)));
      x=Math.max(x, prev_x!==null? prev_x+1:0);
    } else if(crHasVal){ x=Math.round(crMax)+gap; }
    else { x=Math.max(Math.floor(flow_x),0); }
    pos.push(x);
    for(let i=0;i<gh;i++){ const r=g.R[i]; if(r===null) continue; const y=yo+i; const absR=x+r; if(Number.isNaN(cr[y])||absR>cr[y]) cr[y]=absR; }
    prev_x=x; prev_w=w; flow_x=x+w+gap; prevShort=isShort;
  }
  return pos;
}
if(typeof module!=='undefined' && module.exports){ module.exports={computePositions, percentile}; }

if(typeof require!=='undefined' && require.main===module){
  const fs=require('fs');
  const fx=JSON.parse(fs.readFileSync('kern_fixture.json','utf8'));
  let allok=true;
  for(const [word,d] of Object.entries(fx)){
    const glyphs=d.glyphs.map(g=> g.space?{space:true}:{w:g.w,h:g.h,yoff:g.yoff,L:g.L,R:g.R});
    const js=computePositions(glyphs, d.base_h, d.gap, 40);
    const py=d.positions;
    const ok=JSON.stringify(js)===JSON.stringify(py);
    allok=allok&&ok;
    console.log(`${word.padEnd(9)} ${ok?'✓ KHỚP':'✗ LỆCH'}`);
    if(!ok){ console.log('  JS:',JSON.stringify(js)); console.log('  PY:',JSON.stringify(py)); }
  }
  console.log(allok?'\n>>> PORT JS KHỚP 100% PYTHON':'\n>>> CÓ LỆCH');
}
